import { render } from "./HotNewsView.vue?vue&type=template&id=2f502cbf&scoped=true"
import script from "./HotNewsView.vue?vue&type=script&lang=js"
export * from "./HotNewsView.vue?vue&type=script&lang=js"

import "./HotNewsView.vue?vue&type=style&index=0&id=2f502cbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f502cbf"]])

export default __exports__